import { render, staticRenderFns } from "./survey-list.vue?vue&type=template&id=36891315&"
import script from "./survey-list.vue?vue&type=script&lang=js&"
export * from "./survey-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/planorama/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36891315')) {
      api.createRecord('36891315', component.options)
    } else {
      api.reload('36891315', component.options)
    }
    module.hot.accept("./survey-list.vue?vue&type=template&id=36891315&", function () {
      api.rerender('36891315', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/surveys/survey-list.vue"
export default component.exports